import api from './client/axios';

// /**
//  * Fetches all field notes from the server.
//  * @returns {Promise<FieldNote[]>} A promise that resolves to an array of field notes.
//  */
// export const getFieldNotes = async (): Promise<any> => {
//   try {
//     const response = await api.get('/layers/field-notes');
//     return response.data.fieldNotes;
//   } catch (error) {
//     throw new Error('Could not retrieve field notes.');
//   }
// };
export const getFieldCorrections = async (ticketId: string): Promise<any> => {
  const response = await api.get(`/field-corrections/${ticketId}`);
  return response.data.data;
};

export const updateFieldCorrection = async (
  correctionData: any,
): Promise<any> => {
  const response = await api.put(
    `/field-corrections/${correctionData.id}/update`,
    correctionData,
  );
  return response.data.data;
};

export const createFieldCorrection = async (
  correctionData: any,
): Promise<any> => {
  const response = await api.post('/field-corrections', correctionData);
  return response.data.data;
};
